import React, { useState, useCallback, useTransition } from 'react';
import { filtersUser } from '../../interpreter/login';
import { getRolUser } from "../../interpreter/role";
import { FaSearch } from "react-icons/fa";

const UserFilter = ({ setRoles }) => {
    const [searchData, setSearchData] = useState({ email: "" });
    const [isPending, startTransition] = useTransition();

    const handleInputChange = (e) => {
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
    };

    const handleSubmit = useCallback(async () => {
        const email = searchData.email.trim();

        startTransition(async () => {
            try {
                let data;
                if (!email) {
                    const all = await getRolUser();
                    setRoles(all?.user || []);
                } else {
                    const filtered = await filtersUser(email);
                    if (!filtered || filtered.length === 0) {
                        alert("No se encontraron coincidencias");
                        setRoles([]);
                        return;
                    }
                    setRoles(filtered);
                }
            } catch (err) {
                console.error("Error al buscar usuarios", err);
            }
        });
    }, [searchData.email, setRoles]);

    return (
        <div className="bg-white p-4 shadow-md rounded-lg mb-4">
            <h3 className="text-lg font-semibold mb-2 text-left">Buscador</h3>

            <div className="flex items-center gap-4">
                <input
                    type="text"
                    name="email"
                    placeholder="Buscar por correo ..."
                    value={searchData.email}
                    onChange={handleInputChange}
                    className="border p-2 rounded h-8 w-full"
                />
                <button
                    onClick={handleSubmit}
                    disabled={isPending}
                    className={`mt-2 ${isPending ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-500"} text-white rounded flex items-center justify-center w-32 h-8`}
                >
                    {isPending ? (
                        <div className="animate-spin h-4 w-4 border-t-2 border-white border-solid rounded-full" />
                    ) : (
                        <>
                            <FaSearch className="mr-1" />
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default UserFilter;
